﻿import { DateString } from '@core/_globals/types/date-settings';
import { validDate, validDateOfBirth, validName } from '@core/services/custom-validators';
import { email, maxLength, minLength, numeric, required } from '@regle/rules';

export default class ApplicationsPreFilledData {
	language?: string = null;
	firstName?: string = null;
	lastName?: string = null;
	dateOfBirth?: DateString = null;
	phoneNumber?: string = null;
	emailAddress?: string = null;
	storeCode?: string = null;
	constructor(init?: Partial<ApplicationsPreFilledData>) {
		if (init) {
			this.language = init.language;
			this.firstName = init.firstName;
			this.lastName = init.lastName;
			this.dateOfBirth = init.dateOfBirth;
			this.phoneNumber = init.phoneNumber;
			this.emailAddress = init.emailAddress;
			this.storeCode = init.storeCode;
		}
	}

	getPropertyValue(propertyName: keyof ApplicationsPreFilledData) {
		return this[propertyName];
	}

	validation() {
		// const validation = inferRules(ref<ApplicationsPreFilledData>(), {
		// 	language: {},
		// 	firstName: {},
		// 	lastName: {},
		// 	dateOfBirth: {},
		// 	phoneNumber: {},
		// 	emailAddress: {},
		// 	storeCode: {},
		// });
		const validation = {
			language: {},
			firstName: {},
			lastName: {},
			dateOfBirth: {},
			phoneNumber: {},
			emailAddress: {},
			storeCode: {},
		};

		validation.firstName = {
			required,
			valid: validName,
		};
		validation.lastName = {
			required,
			valid: validName,
		};
		validation.dateOfBirth = {
			required,
			validDate,
			validDateOfBirth,
			// minLength: minLength(10),
		};
		validation.emailAddress = { required, email };
		validation.phoneNumber = {
			required,
			numeric,
			minLength: minLength(10),
			maxLength: maxLength(10),
		};
		validation.language = { required };

		return validation;
	}
}
